import React from 'react';
export default function ChildAgeLimitFields({ value = {}, onChange, disabled = false }) {
  return <div className="form-group">
    <label>Children must be under (age)
      <input className="form-input" type="number" min="1" max="100" step="1" placeholder="No age limit" value={value.childMaxAge ?? ''} disabled={disabled} onChange={event => onChange({ childMaxAge: event.target.value === '' ? null : Number(event.target.value) })} />
    </label>
    {value.childMaxAge && <label>When child eligibility ends
      <select className="form-input" value={value.childAgeCutoff || 'renewal'} disabled={disabled} onChange={event => onChange({ childAgeCutoff: event.target.value })}>
        <option value="renewal">Next renewal after reaching the limit</option>
        <option value="birthday">On their birthday</option>
      </select>
    </label>}
    <p className="text-muted small">Optional. Existing covered children keep their current coverage until renewal when a new restriction is applied.</p>
  </div>;
}
